var map = {
	"./DailyRosterLogo.png": 44777,
	"./ShiftWorks_Logo.png": 90026,
	"./StaffWorks_Logo.png": 88184,
	"./Switch Shift Icon_2-01.svg": 18180,
	"./apparatus.png": 32421,
	"./approve.svg": 62555,
	"./bid.svg": 43577,
	"./btn_google_signin_dark_normal_web.png": 62813,
	"./calendar_mouse.jpg": 15750,
	"./callout.svg": 32196,
	"./cancel.svg": 31350,
	"./circle-solid.svg": 52962,
	"./clockin.svg": 3571,
	"./clockout.svg": 20470,
	"./completedShift.png": 10277,
	"./create.svg": 76740,
	"./cross_station.png": 95827,
	"./day.png": 25348,
	"./delete.svg": 57657,
	"./deny.svg": 27822,
	"./dutyBadge.png": 35175,
	"./duty_sm.png": 10421,
	"./edit.svg": 89188,
	"./editShift.png": 26458,
	"./emptyShift.png": 80009,
	"./emptyUserSpecificShift.png": 55934,
	"./envelope_open.svg": 69183,
	"./event.svg": 9096,
	"./exchange.svg": 1079,
	"./filledShift.png": 16338,
	"./full.svg": 40863,
	"./header_background_main.jpg": 44786,
	"./lateShift.png": 55946,
	"./month.png": 30772,
	"./netDutyLogo.png": 4018,
	"./netDutyLogo_police.png": 45853,
	"./netDuty_logo.png": 4033,
	"./netDuty_logo2.png": 18919,
	"./offer.svg": 2098,
	"./offer2.svg": 65964,
	"./onDutyPolice.png": 58589,
	"./onduty.svg": 61047,
	"./overtime.png": 31105,
	"./partial.svg": 40371,
	"./partialShift.png": 92245,
	"./payperiod.png": 7227,
	"./pto.svg": 90515,
	"./reports.svg": 20009,
	"./scheduled_duty.svg": 4240,
	"./shift.svg": 69412,
	"./shiftboard.png": 56636,
	"./signup.svg": 38452,
	"./signup_event.svg": 63721,
	"./softWarning.png": 54638,
	"./station.png": 76090,
	"./sub.svg": 64702,
	"./time_change.svg": 12514,
	"./timeclock_record.svg": 99765,
	"./timeoff.svg": 38138,
	"./userSpecificShift.png": 93949,
	"./vertcleSilverline.png": 18146,
	"./verticleLine.png": 72026,
	"./warning.png": 46070,
	"./week.png": 50892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87958;